import React, { useState } from 'react';
import { checkCanFillForm } from '../../services/api/formApi';

const EmailCollectionModal = ({ isOpen, onSubmit, onClose, mandatory = true, formId }) => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!email.trim()) {
      setError('Email is required');
      return;
    }

    if (!validateEmail(email)) {
      setError('Please enter a valid email address');
      return;
    }

    // Verify if email can fill the form
    if (formId) {
      try {
        setLoading(true);
        const canFill = await checkCanFillForm(formId, email.trim());

        if (!canFill) {
          setError('You have already responded to this form.');
          return;
        }
      } catch (err) {
        console.error('Failed to check email eligibility:', err);
        // On error (e.g. network issue), do we block or allow?
        // Blocking is safer for enforcement, but might block legit users if API acts up.
        // Let's block and show error.
        setError('Unable to verify email eligibility. Please try again.');
        return;
      } finally {
        setLoading(false);
      }
    }

    onSubmit(email.trim());
  };

  if (!isOpen) return null;

  return (
    <div className="modal show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content border-0 shadow-lg rounded-4 overflow-hidden">
          <div className="modal-header border-bottom-0 p-4 pb-0">
            <h5 className="modal-title fw-bold">Email Required</h5>
            {!mandatory && (
              <button type="button" className="btn-close" onClick={onClose}></button>
            )}
          </div>

          <form onSubmit={handleSubmit}>
            <div className="modal-body p-4">
              <p className="text-muted mb-3">Please provide your email address to continue filling this form.</p>
              <div className="mb-3">
                <label htmlFor="email" className="form-label fw-medium">Email address</label>
                <input
                  id="email"
                  type="email"
                  className="form-control form-control-lg"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="your.email@example.com"
                  autoFocus
                  disabled={loading}
                />
                {error && <div className="text-danger small mt-1">{error}</div>}
              </div>
            </div>

            <div className="modal-footer border-top-0 px-4 pb-4 pt-0">
              {!mandatory && (
                <button
                  type="button"
                  className="btn btn-link text-secondary text-decoration-none"
                  onClick={onClose}
                  disabled={loading}
                >
                  Cancel
                </button>
              )}
              <button
                type="submit"
                className="btn btn-primary px-4"
                disabled={loading}
              >
                {loading ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                    Checking...
                  </>
                ) : (
                  'Continue'
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default EmailCollectionModal;

